import { IconButton, Stack, Tooltip } from '@mui/material';
import { Download } from '@mui/icons-material';
import { CompanyTrialsQuery, Trial_Status } from '@generated/graphql';
import CircularLoading from 'components/common/CircularLoading';
import useGenerateTrialFile from 'hooks/useGenerateTrialFile';

interface DownloadReportsActionProps {
  trial: NonNullable<CompanyTrialsQuery['trials']['data']>[number];
}

const DownloadReportsAction = ({ trial }: DownloadReportsActionProps) => {
  const isCompleted = trial.status === Trial_Status.Completed;
  const { onGenerateTrialFile, loading } = useGenerateTrialFile();

  if (!isCompleted) return null;
  return (
    <Stack direction='row' spacing={2}>
      <IconButton onClick={() => onGenerateTrialFile(trial.id)}>
        <Tooltip title='Скачать отчет'>
          {loading ? <CircularLoading sx={{ p: 0 }} size={20} /> : <Download />}
        </Tooltip>
      </IconButton>
    </Stack>
  );
};

export default DownloadReportsAction;
